import type { ReactNode } from 'react';

export const symbol_pan_zoom: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M223-180h97q13 0 21.5 8.5T350-150q0 13-8.5 21.5T320-120H150q-13 0-21.5-8.5T120-150v-170q0-13 8.5-21.5T150-350q13 0 21.5 8.5T180-320v97l127-127q9-9 21.5-9t21.5 9q9 9 9 21.5t-9 21.5L223-180Zm557-557L654-611q-9 9-21 8.5t-21-9.5q-9-9-9-21.5t9-21.5l125-125h-97q-13 0-21.5-8.5T610-810q0-13 8.5-21.5T640-840h170q13 0 21.5 8.5T840-810v170q0 13-8.5 21.5T810-610q-13 0-21.5-8.5T780-640v-97Z"
		/>
	</svg>
);
